import React from 'react';
import './App.css';
import Odds from './components/Odds';

function App() {

  return (
    <div className="App">
      <header className="App-header">
        <Odds />
      </header> 
    </div>
  );
        // <label for="paragons"> Paragons: <input class="paragons" type="number" id="paragons" name="paragons" min="0" /></label>
}

export default App;
